import { List, Spin } from 'antd';
import { type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import ReactInfiniteScroll from 'react-infinite-scroll-component';
import { type LabelsDataFragment, type ModelConfiguratorListDataFragment } from '../../../../api/fragments';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import NoItemResult from '../../../../components/results/NoItemResult';
import { StyledListWrapper } from './ui';
import VehicleListData from './VehicleListData';

type CarListContentProps = {
    shownModels: ModelConfiguratorListDataFragment[];
    total: number;
    loading: boolean;
    onNextPage: () => void;
    hasLabel: boolean;
    setHasLabel: Dispatch<SetStateAction<boolean>>;
    label?: LabelsDataFragment[];
};

const CarListContent = ({
    shownModels,
    total,
    loading,
    onNextPage,
    label,
    hasLabel,
    setHasLabel,
}: CarListContentProps) => {
    const { t } = useTranslation(['configuratorListVehicle']);
    if (loading) {
        return <PortalLoadingElement />;
    }

    if (!loading && total === 0) {
        return <NoItemResult subTitle={t('configuratorListVehicle:noData.message')} />;
    }

    return (
        <StyledListWrapper>
            <ReactInfiniteScroll
                dataLength={shownModels.length}
                hasMore={shownModels.length < total}
                loader={<Spin />}
                next={onNextPage}
                scrollThreshold={0.8}
                style={{ overflow: 'hidden' }}
            >
                <List
                    dataSource={shownModels ?? []}
                    grid={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3, gutter: 24 }}
                    renderItem={shownModels => (
                        <List.Item key={shownModels.id}>
                            <VehicleListData
                                hasLabel={hasLabel}
                                label={label}
                                model={shownModels}
                                setHasLabel={setHasLabel}
                            />
                        </List.Item>
                    )}
                />
            </ReactInfiniteScroll>
        </StyledListWrapper>
    );
};

export default CarListContent;
